export class OrganisationSMTPSettings {
    host = '';
    user = '';
    password = '';
    port = 0;

    serialize(): any {
        return {
            host: this.host,
            user: this.user,
            password: this.password,
            port: this.port,
        };
    }

    deserialize(data:any): this {
        this.host = data.host ?? '';
        this.user = data.user ?? '';
        this.password = data.password ?? '';
        this.port = data.port ?? 0;
        return this;
    }

    clone(): OrganisationSMTPSettings {
        return new OrganisationSMTPSettings().deserialize(this.serialize());
    }
}
